import React, { HTMLAttributes, useMemo } from "react";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
// import store from "store";
import ItemButton, { VerifyTypeEnum } from "../ItemButton";

import styles from "./index.module.scss";
import stylesCommon from "../common.module.scss";
import { FaItemProps } from "../Modal";
import { ModeEnum } from "../Modal/FaType2";

const { useTranslation } = Hooks;

interface Props extends HTMLAttributes<HTMLDivElement> {
  mode: ModeEnum;
  completeTypeAry: VerifyTypeEnum[]; //已完成的验证项数组
  //
  isPasskey: boolean;
  faItems: FaItemProps[];
  clickFun: (arg: VerifyTypeEnum | ModeEnum) => void;
}

const Main: React.FC<Props> = ({ mode, completeTypeAry, isPasskey, faItems, clickFun, className }) => {
  const t = useTranslation();
  // const {isLogin} = store.user;

  const typeAry = useMemo(() => {
    const ary: { type: VerifyTypeEnum; isComplete: boolean }[] = [];
    faItems.map(({ validateItemType }) => {
      const arr = [VerifyTypeEnum.email, VerifyTypeEnum.mobile, VerifyTypeEnum.google];
      const type = arr[validateItemType];
      ary.push({
        type,
        isComplete: completeTypeAry.includes(type),
      });
    });
    return ary;
  }, [faItems, completeTypeAry]);
  const completeNumberLabel = useMemo(() => {
    if (mode === ModeEnum.listPasskey) return "0/1";
    return completeTypeAry.length + "/" + faItems.length;
  }, [mode, completeTypeAry, faItems]);

  return (
    <div className={cx(styles.main, className)}>
      <div className={cx(styles.titleTip)}>{t("@xt/Passkey.plsCompleteSafeVerify")}</div>
      <div className={cx(styles.completeNumber)}>{completeNumberLabel}</div>

      {mode === ModeEnum.listPasskey && (
        <>
          <div className={styles.itemButtons}>
            <ItemButton type={VerifyTypeEnum.passkey} arrow={true} desc onClick={() => clickFun(VerifyTypeEnum.passkey)} />
          </div>
          <div className={styles.option}>
            <button className={cx(stylesCommon.btnTxt)} onClick={() => clickFun(ModeEnum.list)}>
              {t("@xt/Passkey.myPasskeyCannotUse")}
            </button>
          </div>
        </>
      )}
      {mode === ModeEnum.list && (
        <>
          <div className={styles.itemButtons}>
            {typeAry.map(({ type, isComplete }) => (
              <ItemButton key={type} type={type} onClick={() => clickFun(type)} arrow={true} arrowSuccess={isComplete} />
            ))}
          </div>
          {isPasskey && (
            <div className={styles.option}>
              <button className={cx(stylesCommon.btnTxt)} onClick={() => clickFun(ModeEnum.listPasskey)}>
                {t("@xt/Passkey.usePasskeyVerify")}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Main;
